import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { createDespesaDiretaCadastro, updateDespesaDiretaCadastro } from '../service';
import {
  CREATE_DESPESA_DIRETA_CADASTRO,
  CREATE_DESPESA_DIRETA_CADASTRO_PENDING,
  CREATE_DESPESA_DIRETA_CADASTRO_SUCCESS,
  CREATE_DESPESA_DIRETA_CADASTRO_FAILURE,
} from '@handler';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateDespesaDiretaCadastro(action) {
  yield put({ type: CREATE_DESPESA_DIRETA_CADASTRO_PENDING });

  try {
    if (action.data.id === undefined || action.data.id === null) {
      yield call(createDespesaDiretaCadastro, action.data);
      trackingEventCX('action', MODULE_ACTIONS_ENUM.DESPESA_DIRETA_CRIAR);
    } else {
      yield call(updateDespesaDiretaCadastro,
        {
          ...action.data,
          id: action.data.id
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.DESPESA_DIRETA_EDITAR);
    }

    yield put({ type: CREATE_DESPESA_DIRETA_CADASTRO_SUCCESS, registro: action.data });

    if (!action.isCadastroRapido) {
      history.push('/despesaDiretaCadastro');

      AlertSuccess('Registro salvo com sucesso!');
    } else {
      AlertSuccess('Despesa Direta salva com sucesso!');
    }
  } catch (error) {
    yield put({ type: CREATE_DESPESA_DIRETA_CADASTRO_FAILURE, registro: action.data });
    AlertError('Falha ao salvar o registro! Tente novamente...');
  }

}

export default function* watchCreateDespesaDiretaCadastro() {
  yield takeLatest(CREATE_DESPESA_DIRETA_CADASTRO, sagaCreateDespesaDiretaCadastro);
}
